export default __webpack_public_path__ + "static/media/case2-2 (4).38905076.png";